import { styles } from "./QuotationsList.style";
import { orderBy } from "lodash";

import * as React from "react";
import {
    ExpansionPanel,
    ExpansionPanelActions,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Grid,
    Table,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { User } from "../../models/User.model";
import { Quotation } from "../../types/Quotation";
import { Customer } from "../../types/Customer";
import { getProductTitle, getDate } from "../../helper/functions.helper";

import { ActionHistory } from "../../types/ActionHistory";
import ActionHistoryItem from "../ActionHistoryItem/ActionHistoryItem";

import { last } from "lodash";
import QuotationActions from "../QuotationActions/QuotationActions";

type QuotationsListItem = {
    quotation: Quotation;
    customer: Customer;
};

interface QuotationsListProps {
    advisor: User;
    displayHead?: boolean;
    quotationsList?: QuotationsListItem[];
    onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, customerId: string);
}

interface QuotationsListState {
    action: string;
    filter: string;
    order: "asc" | "desc";
}

class QuotationsList extends React.Component<QuotationsListProps & WithStyles<typeof styles>, QuotationsListState> {

    state: QuotationsListState = {
        action: null,
        order: "asc",
        filter: "date"
    };    

    public render() {
        return (
            <Table>
                <TableBody>
                    {this.getQuotations().map((item, iIndex) => (
                        <TableRow key={item.quotation.id || iIndex}>
                            <TableCell className={this.props.classes.cell} colSpan={this.props.displayHead ? 5 : 0}>
                                <ExpansionPanel defaultExpanded={!iIndex}>
                                    {this.renderSummary(item)}    
                                    {this.renderDetail(item)}                                   
                                </ExpansionPanel>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    private renderSummary(item) {
        return (
            <ExpansionPanelSummary className={this.props.classes.summary} expandIcon={<ExpandMoreIcon/>}>
                <Typography className={this.props.classes.summaryDate}>
                    {getDate(item.quotation.creationDate)}
                </Typography>
                <Typography className={this.props.classes.summaryLabel}>
                    <b>{getProductTitle(item.quotation.productName, item.quotation.productVariantName)}</b>
                </Typography>
                <Typography className={this.props.classes.summaryName}>
                    {item.customer.firstname} {item.customer.lastname}
                </Typography>
                <ActionHistoryItem actionHistory={last(item.quotation.actionHistory)}/>
            </ExpansionPanelSummary>
        );
    }

    private renderDetail(item) {
        return (
            <ExpansionPanelDetails className={this.props.classes.panelDetails}>
                <Grid container={true}>
                    <Typography variant="headline">Historique des actions</Typography>
                    <div className={this.props.classes.history}>
                        {this.getActionHistory(item.quotation).map((action, sIndex) => (
                            <div className={this.props.classes.step} key={sIndex}>
                                <ActionHistoryItem actionHistory={action}/>
                            </div>
                        ))}
                    </div>
                    <ExpansionPanelActions className={this.props.classes.panelActions}>
                        <QuotationActions
                            advisor={this.props.advisor}
                            customer={item.customer}
                            quotation={item.quotation}
                            onActionPerformed={(quotation: Quotation, actionHistory: ActionHistory) => this.onActionPerformed(quotation, actionHistory, item.customer)}
                        />
                    </ExpansionPanelActions>
                </Grid>
            </ExpansionPanelDetails>
        );
    }

    private getQuotations() {
        return this.props.quotationsList.sort((a: QuotationsListItem, b: QuotationsListItem) => {
            const dateA = new Date(a.quotation.creationDate).getTime();
            const dateB = new Date(b.quotation.creationDate).getTime();
            return ( dateB - dateA );
        });
    }

    private getActionHistory(quotation: Quotation) {
        let actionHistory = [];
        if ( quotation.actionHistory ) {
            actionHistory = orderBy(quotation.actionHistory, "date", "desc");
        }
        return actionHistory;
    }

    private onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, customer: Customer) {
        if (this.props.onActionPerformed && customer) {
            this.props.onActionPerformed(quotation, actionHistory, customer.id);
        }
    }

}

export default withStyles(styles )(QuotationsList);

/*displayHead && (
                    <TableHeadSortable
                        order={order}
                        orderBy={filter}
                        rows={rows}
                        onRequestSort={(property: string) => this.handleRequestSort(property)}
                    />
                )*/

   /*
    private handleRequestSort (property: string) {
        this.setState({
            order: (this.state.filter === property && this.state.order === "desc") ? "asc" : "desc",
            filter: property
        });
    }
    */

    /*
        const orderedQuotations: QuotationsListItem[] = orderBy(
            quotationsList,
            item => {
                // TODO: @bm - merge into customer data?
                switch (filter) {
                    case "client":
                        return item.customer.lastname;
                    case "product":
                        // TODO: @bm - works in CustomerTable, no in here :/
                        return 1;
                        // return getProductTitle(item.quotation.productName, item.quotation.productVariantName);
                    case "status":
                        // TODO: @ab - finish sorting properly (with quotation status)
                        return 1;
                    default:
                        return item.quotation.creationDate;
                }
            },
            [order]
        );
    */


// WEBPACK FOOTER //
// ./src/components/QuotationsList/QuotationsList.tsx